import * as React from 'react'
import clsx from 'clsx'
import { useStyles } from './styles'

const CustomLeftArrow = ({ onClick }) => {
    const classes = useStyles()
    return (
        <button
            aria-label="Go to previous slide"
            className={clsx('react-multiple-carousel__arrow react-multiple-carousel__arrow--left', classes.arrow)}
            onClick={onClick}
        />
    )
}
const CustomRightArrow = ({ onClick }) => {
    const classes = useStyles()
    return (
        <button
            aria-label="Go to next slide"
            className={clsx('react-multiple-carousel__arrow react-multiple-carousel__arrow--right', classes.arrow)}
            onClick={onClick}
        />
    )
}

export { CustomLeftArrow, CustomRightArrow }
